import { Record, Union } from "../../../fable_modules/fable-library-js.4.24.0/Types.js";
import { unit_type, tuple_type, class_type, record_type, union_type } from "../../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { RetailPrice__ToOption, Prices, RetailPrice as RetailPrice_1, SalesStats_$reflection, Prices_$reflection } from "../../../Shopfoo.Domain.Types/Sales.js";
import { Remote_ofOption, Remote_ofResult, Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505, Remote$1, ApiCall$1, ApiRequestArgs$2, Cmder__ofApiRequest_Z503C4AF9, ApiCall$1_$reflection, Remote$1_$reflection } from "../../../Remoting.js";
import { PurchasePrices_$reflection, Stock_$reflection } from "../../../Shopfoo.Domain.Types/Warehouse.js";
import { PricesApi_GetPricesResponse, PricesApi_PriceCommand, FullContext__get_Now, ServerError, PricesApi_GetSalesStatsResponse_$reflection, PricesApi_GetPurchasePricesResponse_$reflection, PricesApi_GetPricesResponse_$reflection } from "../../../Shopfoo.Shared/Remoting.js";
import { ApiError_Technical_Z184EB5A, ApiError_$reflection } from "../../../Shopfoo.Shared/Errors.js";
import { Result_Map, FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Money__get_ValueWithCurrencySymbol, Money__get_Value, MoneyModule_tryCompute, SKU_$reflection } from "../../../Shopfoo.Domain.Types/Common.js";
import { singleton } from "../../../fable_modules/fable-library-js.4.24.0/AsyncBuilder.js";
import { interpolate, toText } from "../../../fable_modules/fable-library-js.4.24.0/String.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { singleton as singleton_1, ofArray } from "../../../fable_modules/fable-library-js.4.24.0/List.js";
import { Result_tryGetError } from "../../../Shopfoo.Common/Common.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { compare, createObj, equals } from "../../../fable_modules/fable-library-js.4.24.0/Util.js";
import { TranslationPages_Product__get_Stock, TranslationPages_Product__get_AverageOver1Y, TranslationPages_Product__get_StockAction, TranslationPages_Product__get_Margin, TranslationPages_Product__get_LastPurchase, TranslationPages_Product__get_Quantity, TranslationPages_Product__get_TotalSalesOver1Y, TranslationPages_Product__get_SaleAction, TranslationPages_Home__FormatDate_137ECF4, TranslationPages_Product__get_LastSale, TranslationPages_Home__get_Colon, TranslationPages_Product__get_Discount, TranslationPages_Product__get_RetailPrice, TranslationPages_Product__get_ListPrice, $007CTranslationsMissing$007C_$007C, TranslationPages_Product__get_Actions, AppTranslations__get_Product, TranslationPages_Product__get_PriceAction, TranslationPages_Home__Error_Z721C83C5, TranslationPages_Home__get_Completed, AppTranslations__get_Home, TranslationPages_Home__get_StandardDateFormat } from "../../../Shopfoo.Shared/Translations.js";
import { PriceAction_Icons_soldOut, PriceAction_Icons_remove, PriceAction_Icons_decrease, PriceIntent, PriceType__To, PriceAction_Icons_increase, Drawer, PriceType, PriceType__ToDefine_Z55B79C7B, DrawerControl__Open_Z6ACBEE1E, PriceAction_Icons_define, DrawerControl__OnClose_Z63060278, DrawerControl__OnOpen_Z63060278 } from "../Shared.js";
import { JS_runAfter, JS_blurActiveElement } from "../../../UI.js";
import { empty, singleton as singleton_2, append, delay, toList, iterate } from "../../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { bind, map, unwrap, toArray } from "../../../fable_modules/fable-library-js.4.24.0/Option.js";
import { Buttons_SaveButton_Z19F3502D } from "../../../Components/Buttons.js";
import { ModalDialog, DialogProps_get_Empty, DialogProps_Warning_8DF871A, DialogProps_Confirmation_FE1BE0D } from "../../../Components/Dialog.js";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { PageCode } from "../../../Shopfoo.Domain.Types/Translations.js";
import { apiError as apiError_4 } from "../../../Components/Alert.js";
import { Value, ActionProps_withIcon, Value_get_OfMoneyOptional, ActionsDropdown } from "../../../Components/Actions.js";
import { Feat, User__AccessTo_Z21948E14 } from "../../../Shopfoo.Domain.Types/Security.js";
import { op_Subtraction, fromParts, op_Multiply, op_Division, round } from "../../../fable_modules/fable-library-js.4.24.0/Decimal.js";
import { icon as icon_11 } from "../../../Components/Icon.js";
import cash_register from "@iconify-icons/fa6-solid/cash-register";
import warehouse from "@iconify-icons/fa6-solid/warehouse";
import pencil from "@iconify-icons/fa6-solid/pencil";

class Action extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["None", "MarkAsSoldOut", "WarnMarkAsSoldOutForbidden", "RemoveListPrice", "SavePrices"];
    }
}

function Action_$reflection() {
    return union_type("Shopfoo.Client.Pages.Product.Details.Actions.Action", [], Action, () => [[], [], [], [], []]);
}

class Dialog extends Record {
    constructor(Action) {
        super();
        this.Action = Action;
    }
}

function Dialog_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Details.Actions.Dialog", [], Dialog, () => [["Action", Action_$reflection()]]);
}

class Model extends Record {
    constructor(Prices, PriceActionStatus, Stock, PurchasePriceStats, SalesStats) {
        super();
        this.Prices = Prices;
        this.PriceActionStatus = PriceActionStatus;
        this.Stock = Stock;
        this.PurchasePriceStats = PurchasePriceStats;
        this.SalesStats = SalesStats;
    }
}

function Model_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Details.Actions.Model", [], Model, () => [["Prices", Remote$1_$reflection(Prices_$reflection())], ["PriceActionStatus", tuple_type(Action_$reflection(), Remote$1_$reflection(class_type("System.DateTime")))], ["Stock", Remote$1_$reflection(Stock_$reflection())], ["PurchasePriceStats", Remote$1_$reflection(PurchasePrices_$reflection())], ["SalesStats", Remote$1_$reflection(SalesStats_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PricesFetched", "PurchasePricestatsFetched", "SalesStatsFetched", "StockFetched", "RefreshAfterSupply", "RefreshAfterSale", "PerformAction"];
    }
}

function Msg_$reflection() {
    return union_type("Shopfoo.Client.Pages.Product.Details.Actions.Msg", [], Msg, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PricesApi_GetPricesResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PricesApi_GetPricesResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PricesApi_GetPurchasePricesResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PricesApi_GetPurchasePricesResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [PricesApi_GetSalesStatsResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PricesApi_GetSalesStatsResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Stock_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", Stock_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]], [], [], [["Item1", Action_$reflection()], ["Item2", SKU_$reflection()], ["Item3", ApiCall$1_$reflection(unit_type)]]]);
}

function Cmd_determineStock(cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Prices.DetermineStock(request), (arg) => (new Msg(3, [new FSharpResult$2(1, [arg])])), (arg_1) => (new Msg(3, [new FSharpResult$2(0, [arg_1])]))));
}

function Cmd_loadPrices(cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Prices.GetPrices(request), (arg) => (new Msg(0, [new FSharpResult$2(1, [arg])])), (arg_1) => (new Msg(0, [new FSharpResult$2(0, [arg_1])]))));
}

function Cmd_loadPurchasePrices(cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Prices.GetPurchasePrices(request), (arg) => (new Msg(1, [new FSharpResult$2(1, [arg])])), (arg_1) => (new Msg(1, [new FSharpResult$2(0, [arg_1])]))));
}

function Cmd_loadSalesStats(cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Prices.GetSalesStats(request), (arg) => (new Msg(2, [new FSharpResult$2(1, [arg])])), (arg_1) => (new Msg(2, [new FSharpResult$2(0, [arg_1])]))));
}

function Cmd_perform(action, cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => ((action.tag === 3) ? api.Prices.RemoveListPrice(request) : ((action.tag === 1) ? api.Prices.MarkAsSoldOut(request) : singleton.Delay(() => singleton.Return(new FSharpResult$2(1, [new ServerError(0, [ApiError_Technical_Z184EB5A(toText(interpolate("Unexpected action: %A%P()", [action])))])]))))), (apiError) => (new Msg(6, [action, request.Body.SKU, new ApiCall$1(1, [new FSharpResult$2(1, [apiError])])])), (data) => (new Msg(6, [action, request.Body.SKU, new ApiCall$1(1, [new FSharpResult$2(0, [data])])]))));
}

function init(fullContext, sku) {
    let tupledArg, tupledArg_1, tupledArg_2, tupledArg_3;
    return [new Model(new Remote$1(1, []), [new Action(0, []), new Remote$1(0, [])], new Remote$1(1, []), new Remote$1(1, []), new Remote$1(1, [])), Cmd_batch(ofArray([(tupledArg = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, sku), Cmd_loadPrices(tupledArg[0], tupledArg[1])), (tupledArg_1 = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, sku), Cmd_determineStock(tupledArg_1[0], tupledArg_1[1])), (tupledArg_2 = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, sku), Cmd_loadPurchasePrices(tupledArg_2[0], tupledArg_2[1])), (tupledArg_3 = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, sku), Cmd_loadSalesStats(tupledArg_3[0], tupledArg_3[1]))]))];
}

function update(fullContext, sku, onSavePrice, msg, model) {
    let tupledArg, tupledArg_1, tupledArg_2, tupledArg_3, tupledArg_4;
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.Prices, model.PriceActionStatus, model.Stock, new Remote$1(2, [msg.fields[0].fields[0]]), model.SalesStats), Cmd_none()];
            }
            else {
                return [new Model(model.Prices, model.PriceActionStatus, model.Stock, new Remote$1(3, [msg.fields[0].fields[0].Stats]), model.SalesStats), Cmd_none()];
            }
        case 2:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.Prices, model.PriceActionStatus, model.Stock, model.PurchasePriceStats, new Remote$1(2, [msg.fields[0].fields[0]])), Cmd_none()];
            }
            else {
                return [new Model(model.Prices, model.PriceActionStatus, model.Stock, model.PurchasePriceStats, new Remote$1(3, [msg.fields[0].fields[0].Stats])), Cmd_none()];
            }
        case 3:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.Prices, model.PriceActionStatus, new Remote$1(2, [msg.fields[0].fields[0]]), model.PurchasePriceStats, model.SalesStats), Cmd_none()];
            }
            else {
                return [new Model(model.Prices, model.PriceActionStatus, new Remote$1(3, [msg.fields[0].fields[0]]), model.PurchasePriceStats, model.SalesStats), Cmd_none()];
            }
        case 4:
            return [new Model(model.Prices, model.PriceActionStatus, new Remote$1(1, []), new Remote$1(1, []), model.SalesStats), Cmd_batch(ofArray([(tupledArg = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, sku), Cmd_loadPurchasePrices(tupledArg[0], tupledArg[1])), (tupledArg_1 = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, sku), Cmd_determineStock(tupledArg_1[0], tupledArg_1[1]))]))];
        case 5:
            return [new Model(model.Prices, model.PriceActionStatus, new Remote$1(1, []), model.PurchasePriceStats, new Remote$1(1, [])), Cmd_batch(ofArray([(tupledArg_2 = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, sku), Cmd_loadSalesStats(tupledArg_2[0], tupledArg_2[1])), (tupledArg_3 = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, sku), Cmd_determineStock(tupledArg_3[0], tupledArg_3[1]))]))];
        case 6:
            if (msg.fields[2].tag === 1) {
                let prices_2;
                const matchValue = model.Prices;
                let matchResult, prices, prices_1;
                if (matchValue.tag === 3) {
                    switch (msg.fields[0].tag) {
                        case 1: {
                            matchResult = 0;
                            prices = matchValue.fields[0];
                            break;
                        }
                        case 3: {
                            matchResult = 1;
                            prices_1 = matchValue.fields[0];
                            break;
                        }
                        default:
                            matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
                switch (matchResult) {
                    case 0: {
                        prices_2 = (new Prices(prices.SKU, prices.Currency, new RetailPrice_1(1, []), prices.ListPrice));
                        break;
                    }
                    case 1: {
                        prices_2 = (new Prices(prices_1.SKU, prices_1.Currency, prices_1.RetailPrice, undefined));
                        break;
                    }
                    default:
                        prices_2 = undefined;
                }
                if (prices_2 != null) {
                    const prices_3 = prices_2;
                    return [new Model(new Remote$1(3, [prices_3]), [msg.fields[0], Remote_ofResult(Result_Map(() => FullContext__get_Now(fullContext), msg.fields[2].fields[0]))], model.Stock, model.PurchasePriceStats, model.SalesStats), Cmd_ofEffect((_arg_2) => {
                        onSavePrice([prices_3, Result_tryGetError(msg.fields[2].fields[0])]);
                    })];
                }
                else {
                    return [model, Cmd_none()];
                }
            }
            else {
                return [new Model(model.Prices, [msg.fields[0], new Remote$1(1, [])], model.Stock, model.PurchasePriceStats, model.SalesStats), (tupledArg_4 = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, new PricesApi_PriceCommand(msg.fields[1])), Cmd_perform(msg.fields[0], tupledArg_4[0], tupledArg_4[1]))];
            }
        default:
            if (msg.fields[0].tag === 1) {
                return [new Model(new Remote$1(2, [msg.fields[0].fields[0]]), model.PriceActionStatus, model.Stock, model.PurchasePriceStats, model.SalesStats), Cmd_none()];
            }
            else {
                return [new Model(Remote_ofOption(msg.fields[0].fields[0].Prices), model.PriceActionStatus, model.Stock, model.PurchasePriceStats, model.SalesStats), Cmd_none()];
            }
    }
}

export function ActionsForm(actionsFormInputProps) {
    let $key7673F753, elems_7;
    const setSoldOut = actionsFormInputProps.setSoldOut;
    const onSavePrice = actionsFormInputProps.onSavePrice;
    const drawerControl = actionsFormInputProps.drawerControl;
    const sku = actionsFormInputProps.sku;
    const fullContext = actionsFormInputProps.fullContext;
    const key = actionsFormInputProps.$key;
    let patternInput;
    const init_1 = init(fullContext, sku);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, (msg, model) => update(fullContext, sku, onSavePrice, msg, model), (_arg, _arg_1) => {
    }), undefined, []);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const dependencies_2 = [model_1.Prices];
    reactApi.useEffect(() => {
        const matchValue = model_1.Prices;
        if (matchValue.tag === 3) {
            setSoldOut(equals(matchValue.fields[0].RetailPrice, new RetailPrice_1(1, [])));
        }
    }, dependencies_2);
    const translations = fullContext.Translations;
    const standardDateFormat = TranslationPages_Home__get_StandardDateFormat(AppTranslations__get_Home(translations));
    DrawerControl__OnOpen_Z63060278(drawerControl, (_arg_2) => {
        JS_blurActiveElement();
    });
    DrawerControl__OnClose_Z63060278(drawerControl, (drawer) => {
        switch (drawer.tag) {
            case 0: {
                dispatch(new Msg(0, [new FSharpResult$2(0, [new PricesApi_GetPricesResponse(drawer.fields[1])])]));
                break;
            }
            case 1: {
                dispatch(new Msg(5, []));
                break;
            }
            case 2: {
                dispatch(new Msg(4, []));
                break;
            }
            default:
                dispatch(new Msg(3, [new FSharpResult$2(0, [drawer.fields[0]])]));
        }
    });
    const modalRef = reactApi.useRef(undefined);
    let patternInput_1;
    const initial = new Dialog(new Action(0, []));
    patternInput_1 = reactApi.useState(initial);
    const setDialog = patternInput_1[1];
    const dialog = patternInput_1[0];
    const updateModal = (f) => {
        iterate((_arg_3) => {
            if (_arg_3 instanceof HTMLDialogElement) {
                const dialog_1 = _arg_3;
                f(dialog_1);
            }
        }, toArray(modalRef.current));
    };
    reactApi.useEffect(() => {
        const matchValue_1 = model_1.PriceActionStatus;
        let matchResult, priceAction_1;
        if (matchValue_1[1].tag === 3) {
            if (equals(matchValue_1[0], dialog.Action)) {
                matchResult = 0;
                priceAction_1 = matchValue_1[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                JS_runAfter(500, () => {
                    updateModal((_arg_4) => {
                        _arg_4.close();
                    });
                });
                break;
            }
            case 1: {
                break;
            }
        }
    });
    const openModal = (action_1) => {
        setDialog(new Dialog(action_1));
        updateModal((_arg_5) => {
            _arg_5.showModal();
        });
    };
    const confirmButton = (label) => {
        const $key592D7856 = `${key}-dialog-confirm-price`;
        return createElement(Buttons_SaveButton_Z19F3502D, {
            key: $key592D7856,
            $key: $key592D7856,
            label: label,
            tooltipOk: TranslationPages_Home__get_Completed(AppTranslations__get_Home(translations)),
            tooltipError: (err) => TranslationPages_Home__Error_Z721C83C5(AppTranslations__get_Home(translations), err.ErrorMessage),
            tooltipProps: singleton_1(["className", "tooltip-left"]),
            saveDate: model_1.PriceActionStatus[1],
            disabled: false,
            onClick: () => {
                dispatch(new Msg(6, [dialog.Action, sku, new ApiCall$1(0, [])]));
            },
        });
    };
    let dialogProps;
    const matchValue_2 = dialog.Action;
    switch (matchValue_2.tag) {
        case 3: {
            const x_1 = TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).RemoveListPriceDialog;
            dialogProps = DialogProps_Confirmation_FE1BE0D(translations, x_1.Question, confirmButton(x_1.Confirm));
            break;
        }
        case 2: {
            dialogProps = DialogProps_Warning_8DF871A(translations, TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).WarnMarkAsSoldOutForbidden);
            break;
        }
        case 4:
        case 0: {
            dialogProps = DialogProps_get_Empty();
            break;
        }
        default: {
            const x = TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).MarkAsSoldOutDialog;
            dialogProps = DialogProps_Confirmation_FE1BE0D(translations, x.Question, confirmButton(x.Confirm));
        }
    }
    const xs_27 = [($key7673F753 = (`${key}-dialog`), createElement(ModalDialog, {
        key: $key7673F753,
        $key: $key7673F753,
        ref: modalRef,
        props: dialogProps,
        closeModal: (e) => {
            e.preventDefault();
            updateModal((_arg_6) => {
                _arg_6.close();
            });
            setDialog(new Dialog(new Action(0, [])));
        },
    })), createElement("fieldset", createObj(Helpers_combineClasses("fieldset", ofArray([["key", `${key}-fieldset`], ["className", "bg-base-200 border border-base-300 rounded-box p-4"], (elems_7 = toList(delay(() => append(singleton_2(createElement("legend", {
        key: "product-actions-legend",
        className: "text-sm",
        children: `⚡ ${TranslationPages_Product__get_Actions(AppTranslations__get_Product(translations))}`,
    })), delay(() => {
        let matchValue_3, prices_1;
        return append((matchValue_3 = model_1.Prices, (matchValue_3.tag === 0) ? (empty()) : ((matchValue_3.tag === 1) ? singleton_2(createElement("div", createObj(Helpers_combineClasses("skeleton", ofArray([["className", "h-48 w-full"], ["key", "prices-skeleton"]]))))) : (($007CTranslationsMissing$007C_$007C(new PageCode(2, []), translations) != null) ? singleton_2(createElement("div", createObj(Helpers_combineClasses("skeleton", ofArray([["className", "h-48 w-full"], ["key", "prices-skeleton"]]))))) : ((matchValue_3.tag === 2) ? singleton_2(apiError_4("prices-load-error", matchValue_3.fields[0], fullContext.User)) : ((matchValue_3.tag === 3) ? ((prices_1 = matchValue_3.fields[0], append(singleton_2(createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", "list-price-label"], ["children", TranslationPages_Product__get_ListPrice(AppTranslations__get_Product(translations))]]))))), delay(() => append(singleton_2(createElement(ActionsDropdown, {
            key: "list-price",
            $key: "list-price",
            css: "mb-4",
            access: unwrap(User__AccessTo_Z21948E14(fullContext.User, new Feat(3, []))),
            value: Value_get_OfMoneyOptional()(prices_1.ListPrice),
            actions: toList(delay(() => {
                const matchValue_5 = prices_1.ListPrice;
                if (matchValue_5 == null) {
                    return singleton_2(ActionProps_withIcon("define-list-price", PriceAction_Icons_define, TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).Define, () => {
                        DrawerControl__Open_Z6ACBEE1E(drawerControl, new Drawer(0, [PriceType__ToDefine_Z55B79C7B(new PriceType(0, []), prices_1.Currency), prices_1]));
                    }));
                }
                else {
                    const price = matchValue_5;
                    return append(singleton_2(ActionProps_withIcon("increase-list-price", PriceAction_Icons_increase, TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).Increase, () => {
                        DrawerControl__Open_Z6ACBEE1E(drawerControl, new Drawer(0, [PriceType__To(new PriceType(0, []), new PriceIntent(0, []), price), prices_1]));
                    })), delay(() => append(singleton_2(ActionProps_withIcon("decrease-list-price", PriceAction_Icons_decrease, TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).Decrease, () => {
                        DrawerControl__Open_Z6ACBEE1E(drawerControl, new Drawer(0, [PriceType__To(new PriceType(0, []), new PriceIntent(1, []), price), prices_1]));
                    })), delay(() => singleton_2(ActionProps_withIcon("remove-list-price", PriceAction_Icons_remove, TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).Remove, () => {
                        openModal(new Action(3, []));
                    }))))));
                }
            })),
        })), delay(() => {
            let elems;
            return append(singleton_2(createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", "retail-price-label"], (elems = toList(delay(() => append(singleton_2(TranslationPages_Product__get_RetailPrice(AppTranslations__get_Product(translations))), delay(() => {
                const matchValue_6 = prices_1.ListPrice;
                const matchValue_7 = prices_1.RetailPrice;
                let matchResult_1, listPrice_1, retailPrice_1;
                if (matchValue_6 != null) {
                    if (matchValue_7.tag === 0) {
                        if (compare(matchValue_6, matchValue_7.fields[0]) > 0) {
                            matchResult_1 = 0;
                            listPrice_1 = matchValue_6;
                            retailPrice_1 = matchValue_7.fields[0];
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        const matchValue_9 = MoneyModule_tryCompute(listPrice_1, retailPrice_1, (x_2, y) => round(op_Division(op_Multiply(fromParts(100, 0, 0, true, 0), op_Subtraction(x_2, y)), x_2)));
                        if (matchValue_9 != null) {
                            const discount = matchValue_9;
                            return singleton_2(createElement("div", {
                                key: "discount",
                                className: "ml-auto",
                                children: toText(interpolate("%s%P()%s%P() %.0f%P()%%", [TranslationPages_Product__get_Discount(AppTranslations__get_Product(translations)), TranslationPages_Home__get_Colon(AppTranslations__get_Home(translations)), Money__get_Value(discount)])),
                            }));
                        }
                        else {
                            return empty();
                        }
                    }
                    default: {
                        return empty();
                    }
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))))), delay(() => append(singleton_2(createElement(ActionsDropdown, {
                key: "retail-price",
                $key: "retail-price",
                css: "mb-4",
                access: unwrap(User__AccessTo_Z21948E14(fullContext.User, new Feat(3, []))),
                value: Value_get_OfMoneyOptional()(RetailPrice__ToOption(prices_1.RetailPrice)),
                actions: toList(delay(() => {
                    const matchValue_10 = prices_1.RetailPrice;
                    if (matchValue_10.tag === 1) {
                        return singleton_2(ActionProps_withIcon("define-retail-price", PriceAction_Icons_define, TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).Define, () => {
                            DrawerControl__Open_Z6ACBEE1E(drawerControl, new Drawer(0, [PriceType__ToDefine_Z55B79C7B(new PriceType(1, []), prices_1.Currency), prices_1]));
                        }));
                    }
                    else {
                        const price_1 = matchValue_10.fields[0];
                        return append(singleton_2(ActionProps_withIcon("increase-retail-price", PriceAction_Icons_increase, TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).Increase, () => {
                            DrawerControl__Open_Z6ACBEE1E(drawerControl, new Drawer(0, [PriceType__To(new PriceType(1, []), new PriceIntent(0, []), price_1), prices_1]));
                        })), delay(() => append(singleton_2(ActionProps_withIcon("decrease-retail-price", PriceAction_Icons_decrease, TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).Decrease, () => {
                            DrawerControl__Open_Z6ACBEE1E(drawerControl, new Drawer(0, [PriceType__To(new PriceType(1, []), new PriceIntent(1, []), price_1), prices_1]));
                        })), delay(() => {
                            const matchValue_11 = model_1.Stock;
                            if (matchValue_11.tag === 3) {
                                const action_2 = (matchValue_11.fields[0].Quantity === 0) ? (new Action(1, [])) : (new Action(2, []));
                                return singleton_2(ActionProps_withIcon("mark-as-sold-out", PriceAction_Icons_soldOut, TranslationPages_Product__get_PriceAction(AppTranslations__get_Product(translations)).MarkAsSoldOut, () => {
                                    openModal(action_2);
                                }));
                            }
                            else {
                                return empty();
                            }
                        }))));
                    }
                })),
            })), delay(() => {
                let matchValue_12, salesStats, elems_1;
                return append((matchValue_12 = model_1.SalesStats, (matchValue_12.tag === 3) ? ((salesStats = matchValue_12.fields[0], append(singleton_2(createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", "last-sale-label"], (elems_1 = toList(delay(() => append(singleton_2(TranslationPages_Product__get_LastSale(AppTranslations__get_Product(translations))), delay(() => {
                    const matchValue_13 = salesStats.LastSale;
                    if (matchValue_13 != null) {
                        const sale = matchValue_13;
                        return singleton_2(` (${TranslationPages_Home__FormatDate_137ECF4(AppTranslations__get_Home(translations), sale.Date, standardDateFormat)})`);
                    }
                    else {
                        return empty();
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))), delay(() => append(singleton_2(createElement(ActionsDropdown, {
                    key: "last-sale",
                    $key: "last-sale",
                    css: "mb-0",
                    access: unwrap(User__AccessTo_Z21948E14(fullContext.User, new Feat(3, []))),
                    value: Value_get_OfMoneyOptional()(map((_arg_8) => _arg_8.Price, salesStats.LastSale)),
                    actions: singleton_1(ActionProps_withIcon("input-sales", icon_11(cash_register), TranslationPages_Product__get_SaleAction(AppTranslations__get_Product(translations)).InputSales, () => {
                        DrawerControl__Open_Z6ACBEE1E(drawerControl, new Drawer(1, [prices_1.Currency, map(Money__get_Value, RetailPrice__ToOption(prices_1.RetailPrice))]));
                    })),
                })), delay(() => {
                    let elems_3;
                    return singleton_2(createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", "sales-over-1y-hint"], ["className", "grid grid-cols-[1fr_auto] items-center mb-3 italic"], (elems_3 = toList(delay(() => {
                        let elems_2, matchValue_14;
                        return append(singleton_2(createElement("span", createObj(ofArray([["key", "sales-1y-label"], ["className", "pr-2"], (elems_2 = [`${TranslationPages_Product__get_TotalSalesOver1Y(AppTranslations__get_Product(translations))}${TranslationPages_Home__get_Colon(AppTranslations__get_Home(translations))}  `, (matchValue_14 = salesStats.TotalOver1Y, (matchValue_14 != null) ? Money__get_ValueWithCurrencySymbol(matchValue_14) : "-")], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                            if (salesStats.TotalOver1Y != null) {
                                return singleton_2(createElement("span", {
                                    key: "sales-1y-values",
                                    className: "text-right",
                                    children: `${TranslationPages_Product__get_Quantity(AppTranslations__get_Product(translations))}${TranslationPages_Home__get_Colon(AppTranslations__get_Home(translations))}  ${salesStats.QuantityOver1Y}`,
                                }));
                            }
                            else {
                                return empty();
                            }
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))));
                })))))) : (empty())), delay(() => {
                    let elems_4;
                    const matchValue_16 = prices_1.RetailPrice;
                    const matchValue_17 = model_1.PurchasePriceStats;
                    let matchResult_2, purchasePrices, retailPrice_2;
                    if (matchValue_16.tag === 0) {
                        if (matchValue_17.tag === 3) {
                            matchResult_2 = 0;
                            purchasePrices = matchValue_17.fields[0];
                            retailPrice_2 = matchValue_16.fields[0];
                        }
                        else {
                            matchResult_2 = 1;
                        }
                    }
                    else {
                        matchResult_2 = 1;
                    }
                    switch (matchResult_2) {
                        case 0: {
                            const marginPct = (purchasedPrice) => map(Money__get_Value, MoneyModule_tryCompute(retailPrice_2, purchasedPrice, (r, p) => round(op_Division(op_Multiply(fromParts(100, 0, 0, false, 0), op_Subtraction(r, p)), r))));
                            const lastPurchasePrice = map((tuple) => tuple[0], purchasePrices.LastPrice);
                            return append(singleton_2(createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", "last-purchase-price-label"], (elems_4 = toList(delay(() => append(singleton_2(TranslationPages_Product__get_LastPurchase(AppTranslations__get_Product(translations))), delay(() => {
                                let matchValue_19, date;
                                return append((matchValue_19 = purchasePrices.LastPrice, (matchValue_19 != null) ? ((date = matchValue_19[1], singleton_2(` (${TranslationPages_Home__FormatDate_137ECF4(AppTranslations__get_Home(translations), date, standardDateFormat)})`))) : (empty())), delay(() => {
                                    const matchValue_20 = bind(marginPct, lastPurchasePrice);
                                    if (matchValue_20 != null) {
                                        const margin = matchValue_20;
                                        return singleton_2(createElement("div", {
                                            key: "last-purchase-price-margin",
                                            className: "ml-auto",
                                            children: toText(interpolate("%s%P()%s%P() %.0f%P()%%", [TranslationPages_Product__get_Margin(AppTranslations__get_Product(translations)), TranslationPages_Home__get_Colon(AppTranslations__get_Home(translations)), margin])),
                                        }));
                                    }
                                    else {
                                        return empty();
                                    }
                                }));
                            })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))))), delay(() => append(singleton_2(createElement(ActionsDropdown, {
                                key: "last-purchase-price",
                                $key: "last-purchase-price",
                                css: "mb-0",
                                access: unwrap(User__AccessTo_Z21948E14(fullContext.User, new Feat(3, []))),
                                value: Value_get_OfMoneyOptional()(lastPurchasePrice),
                                actions: singleton_1(ActionProps_withIcon("receive-purchased-products", icon_11(warehouse), TranslationPages_Product__get_StockAction(AppTranslations__get_Product(translations)).ReceivePurchasedProducts, () => {
                                    DrawerControl__Open_Z6ACBEE1E(drawerControl, new Drawer(2, [prices_1.Currency]));
                                })),
                            })), delay(() => {
                                let elems_6, elems_5, matchValue_21, matchValue_22;
                                return singleton_2(createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", "average-purchase-price-hint"], ["className", "grid grid-cols-[1fr_auto] items-center mb-3 italic"], (elems_6 = [createElement("span", createObj(ofArray([["key", "average-label"], (elems_5 = [`${TranslationPages_Product__get_AverageOver1Y(AppTranslations__get_Product(translations))}${TranslationPages_Home__get_Colon(AppTranslations__get_Home(translations))}  `, (matchValue_21 = purchasePrices.AverageOver1Y, (matchValue_21 == null) ? "-" : Money__get_ValueWithCurrencySymbol(matchValue_21))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("span", {
                                    key: "average-margin",
                                    className: "text-right",
                                    children: (matchValue_22 = bind(marginPct, purchasePrices.AverageOver1Y), (matchValue_22 == null) ? "-" : toText(interpolate("%.0f%P()%%", [matchValue_22]))),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))));
                            }))));
                        }
                        default: {
                            return empty();
                        }
                    }
                }));
            }))));
        })))))) : (() => {
            throw new Error("Match failure: Shopfoo.Client.Remoting.Remote`1");
        })()))))), delay(() => {
            const matchValue_23 = model_1.Stock;
            let matchResult_3;
            switch (matchValue_23.tag) {
                case 0: {
                    matchResult_3 = 0;
                    break;
                }
                case 1: {
                    matchResult_3 = 1;
                    break;
                }
                default:
                    if ($007CTranslationsMissing$007C_$007C(new PageCode(2, []), translations) != null) {
                        matchResult_3 = 1;
                    }
                    else {
                        matchResult_3 = 2;
                    }
            }
            switch (matchResult_3) {
                case 0: {
                    return empty();
                }
                case 1:
                    return singleton_2(createElement("div", createObj(Helpers_combineClasses("skeleton", ofArray([["className", "h-24 w-full"], ["key", "stock-skeleton"]])))));
                default:
                    switch (matchValue_23.tag) {
                        case 2:
                            return singleton_2(apiError_4("stock-load-error", matchValue_23.fields[0], fullContext.User));
                        case 3: {
                            const stock_2 = matchValue_23.fields[0];
                            return append(singleton_2(createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", "stock-label"], ["children", TranslationPages_Product__get_Stock(AppTranslations__get_Product(translations))]]))))), delay(() => singleton_2(createElement(ActionsDropdown, {
                                key: "stock",
                                $key: "stock",
                                css: "mb-4",
                                access: unwrap(User__AccessTo_Z21948E14(fullContext.User, new Feat(4, []))),
                                value: new Value(0, [stock_2.Quantity]),
                                actions: singleton_1(ActionProps_withIcon("inventory-adjustment", icon_11(pencil), TranslationPages_Product__get_StockAction(AppTranslations__get_Product(translations)).AdjustStockAfterInventory, () => {
                                    DrawerControl__Open_Z6ACBEE1E(drawerControl, new Drawer(3, [stock_2]));
                                })),
                            }))));
                        }
                        default:
                            throw new Error("Match failure: Shopfoo.Client.Remoting.Remote`1");
                    }
            }
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_7))])]))))];
    return react.createElement(react.Fragment, {}, ...xs_27);
}

